export default {
    state: {
        arr: {}
    },
    getters:{
        TTIME: state=> {
            return state.arr
        }
    },
    mutations: {
        SET_TTIME: (state,payload) =>{
            state.arr=payload
            state.arr.actual='1'
        },
        SET_TTIME_ACTUAL: (state,actual) =>{
            state.arr.actual=actual
        }
    },
    actions: {
        SET_TTIME: (context, payload) => {
             context.commit('SET_TTIME',payload)
        },
        SET_TTIME_ACTUAL: (context, actual) => {
            context.commit('SET_TTIME_ACTUAL',actual)
        }
    },

}